class GoogleAnalysis {
  private readonly analysis?: any;

  constructor() {
    this.analysis = window.Analysis;
  }
  // 直播banner点击
  liveCasinoBannerClick(params?: any) {
    if (!this.analysis) {
      return;
    }
    this.analysis.gtm.trackEvent('live_casino_banner_click', params);
  }
}

export const googleAnalysis = new GoogleAnalysis();
